import React from 'react';
import { MemberArtistSection } from './MemberListSectionParts';
import MemberArtistSectionsBlock from './MemberArtistSectionsBlock';

export default function MemberModalArtistContent({
  showArtistMembers = true,
  isGroupMode = false,
  groupArtistSections = [],
  decidedSections = [],
  undecidedList = [],
  isAllMemberPartScope = false,
  onArtistClick,
  avatarStyle,
  avatarInitial,
  sectionClassName,
  titleClassName,
  listClassName,
  rowClassName,
  avatarClassName,
  infoClassName,
  nameClassName,
  membershipClassName,
  badgesClassName,
  concertmasterBadgeClassName,
  chiefBadgeClassName,
  roleBadgeClassName,
  emptyClassName,
  emptyText = '参加メンバーがいません',
  hiddenText = '参加メンバー決定後公開',
  groupShowMembership = false,
  groupShowBadges = false,
  groupIncludeCustomRoles = false,
  groupSectionTitleBuilder,
  renderGroupMemberTrailing,
  renderArtistMemberTrailing,
}) {
  if (!showArtistMembers) {
    return <div className={emptyClassName}>{hiddenText}</div>;
  }

  if (isGroupMode) {
    return (
      <>
        {groupArtistSections.map((section) => {
          const resolvedSection =
            typeof groupSectionTitleBuilder === 'function'
              ? {
                  ...section,
                  title: groupSectionTitleBuilder(section),
                  titleShort: '',
                }
              : section;
          return (
            <MemberArtistSection
              key={section.id}
              section={resolvedSection}
              onArtistClick={onArtistClick}
              avatarStyle={avatarStyle}
              avatarInitial={avatarInitial}
              sectionClassName={sectionClassName}
              titleClassName={titleClassName}
              listClassName={listClassName}
              rowClassName={rowClassName}
              avatarClassName={avatarClassName}
              infoClassName={infoClassName}
              nameClassName={nameClassName}
              membershipClassName={membershipClassName}
              badgesClassName={badgesClassName}
              concertmasterBadgeClassName={concertmasterBadgeClassName}
              chiefBadgeClassName={chiefBadgeClassName}
              roleBadgeClassName={roleBadgeClassName}
              showMembership={groupShowMembership}
              showBadges={groupShowBadges}
              includeCustomRoles={groupIncludeCustomRoles}
              renderTrailing={renderGroupMemberTrailing}
            />
          );
        })}
        {groupArtistSections.length === 0 ? (
          <div className={emptyClassName}>{emptyText}</div>
        ) : null}
      </>
    );
  }

  return (
    <MemberArtistSectionsBlock
      decidedSections={decidedSections}
      undecidedList={undecidedList}
      isAllMemberPartScope={isAllMemberPartScope}
      onArtistClick={onArtistClick}
      avatarStyle={avatarStyle}
      avatarInitial={avatarInitial}
      sectionClassName={sectionClassName}
      titleClassName={titleClassName}
      listClassName={listClassName}
      rowClassName={rowClassName}
      avatarClassName={avatarClassName}
      infoClassName={infoClassName}
      nameClassName={nameClassName}
      membershipClassName={membershipClassName}
      badgesClassName={badgesClassName}
      concertmasterBadgeClassName={concertmasterBadgeClassName}
      chiefBadgeClassName={chiefBadgeClassName}
      roleBadgeClassName={roleBadgeClassName}
      emptyClassName={emptyClassName}
      emptyText={emptyText}
      renderTrailing={renderArtistMemberTrailing}
    />
  );
}
